<template>
  <div class="home">
    <div class="body">
      <div class="viewBody">
        <div class="view_1">
          <div class="_1">¡Alerta de seguridad!</div>
          <div class="_2">
            No envíes dinero a personas o cuentas bancarias fuera de nuestro
            sitio.
          </div>
          <div class="_2">
            Para tu seguridad, paga tu préstamo únicamente usando nuestro portal
            oficial.
          </div>
          <!-- <div class="store">
          
            <a href="https://t.copii.co/11DQHX" target="_blank" >
                <img src="@/assets/icon/apk.png"  class="img">
            </a>
            
           
          </div> -->
        </div>

        <div class="view_2">
          <div class="title">
            <div class="left">¿Cuánto vas a necesitas?</div>
            <div class="right">${{ amountFormato | formatos }}</div>
          </div>
          <sliderView
            :min="0"
            :max="100"
            :value="sliderValue"
            @move="sliderChange"
          ></sliderView>
          <div class="title_2">
            <div class="left">$100,000</div>
            <div class="right">$3,000,000</div>
          </div>
          <div class="title_3">Plazo</div>
          <div class="dayView">
            <div
              class="day"
              :class="{ active: dayIndex == 91 }"
              @click="dayClick(91)"
            >
              <span class="num">91</span><span class="text">Días</span>
            </div>
            <div
              class="day middle"
              :class="{ active: dayIndex == 120 }"
              @click="dayClick(120)"
            >
              <span class="num">120</span><span class="text">Días</span>
            </div>
            <div
              class="day"
              :class="{ active: dayIndex == 150 }"
              @click="dayClick(150)"
            >
              <span class="num">150</span><span class="text">Días</span>
            </div>
          </div>

          <!-- <div class="button" @click="goNext()">Solicítalo Ahora</div> -->
          <div class="buttonJIeshi">
            Por ejemplo: para un préstamo de $1,000,000 pesos con un plazo de
            120 días, tasa de interés diaria 0,09%（APR 32,85%）<br />

            - el monto que usted recibe es $1,000,000 pesos<br />
            - el interés total es $1,000,000*120*0,09%=$108,000 pesos<br />
            - el monto total de pago es $1,000,000+$108,000=$1,108,000 pesos<br />
            - el monto de pago mensual es $277,000 pesos
          </div>
        </div>
        <div class="view_3">
          <div class="_1">¡Alerta de seguridad!</div>
          <div class="_2">
            No envíes dinero a personas o cuentas bancarias fuera de nuestro
            sitio.
          </div>
          <div class="_2">
            Para tu seguridad, paga tu préstamo únicamente usando nuestro portal
            oficial.
          </div>
          <!-- <div class="store">
          
            <a href="https://t.copii.co/11DQHX" target="_blank" >
                <img src="@/assets/icon/apk.png"  class="img">
            </a>
            
           
          </div> -->
        </div>
      </div>
    </div>
    <describeView></describeView>
    <advantageView></advantageView>
    <fastView v-if="false"></fastView>
  </div>
</template>

<script>
  import sliderView from "@/components/slider/index.vue";
import describeView from "@/components/component/describeView.vue";
import advantageView from "@/components/component/advantageView.vue";
import fastView from "@/components/component/fastView.vue";
export default {
  name: "notLoggedIn",
  components: {
    fastView,
    advantageView,
    describeView,
    sliderView
  },
  data() {
    return {
      sliderValue: 47,
      dayIndex: 150,
      amountTimeout: null,
      dayTimeout: null,
      openAppShow: false,
      step: null,
    };
  },
  mounted() {
    this.$sensors.track("home_page_view", {});
    if (this.pageToApkStrategy == 2) {
      this.openAppShow = true;
    }
  },
  computed: {
    pageToApkStrategy() {
      return this.$store.getters["getPageToApkStrategy"];
    },
    amountFormato() {
      let num =
        Math.floor((2900000 * (this.sliderValue / 100)) / 10000) * 10000 +
        100000;
      if (num == 990000) {
        return 1000000;
      } else {
        return num;
      }
    },
    interes() {
      return (this.amountFormato * 0.0009 * this.dayIndex).toFixed(0);
    },
    tarifa() {
      return (this.amountFormato * 0.1).toFixed(0);
    },
    total() {
      return (
        Number(this.amountFormato) +
        Number(this.interes) +
        Number(this.tarifa)
      ).toFixed(0);
    },
    fecha() {
      let date = new Date();
      date.setDate(date.getDate() + this.dayIndex);

      let year = date.getFullYear(); // 获取年份
      let month = (date.getMonth() + 1).toString().padStart(2, "0");
      let day = date.getDate().toString().padStart(2, "0");

      return `${day}/${month}/${year}`;
    },
  },
  methods: {
    goNext() {
    
      if (this.$store.getters["getToken"]) {
        let step = this.$store.getters["getUserStepUrl"];
        if (step != null) {
          this.$router.push({
            path: "/supplement-information",
          });
        }
      } else {
        this.$router.push({
          path: "/login",
        });
      }
    },
    sliderChange(e) {
      this.sliderValue = e;

     
    },
    dayClick(e) {
      this.dayIndex = e;

    },
    descargar() {
      // buryingPoint('clickDownloadApkOnH')
    },
  },
  filters: {
    formatos(e) {
      return String(e).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
<style scoped lang="scss">
@media only screen and (min-width: 901px) {
  .home {
    .body {
      height: 700px;
      background-image: url("../assets/view/11180.png");
      background-repeat: no-repeat;
      background-color: #17b7bd;
      background-position: 50%;
      background-size: cover;
      padding: 38px 0px;

      .viewBody {
        max-width: 1070px;
        padding: 0 15px;
        margin: 0 auto;
        display: flex;

        justify-content: space-between;

        .view_1 {
          margin-top: 100px;
          text-align: left;
          max-width: 400px;

          ._1 {
            height: 90px;
            font-family: Poppins, Poppins;
            font-weight: bold;
            font-size: 36px;
            color: #ffffff;
            line-height: 45px;

            span {
              color: #fff52f;
            }
          }

          ._2 {
            margin-top: 10px;
            font-weight: bold;
            font-size: 17px;
            color: #ffffff;
            line-height: 23px;
          }
          .store {
            display: flex;
            align-items: center;

            margin-top: 15px;
            .img {
              height: 38px;
              margin-right: 10px;
            }
          }
        }

        .view_2 {
          margin-top: 100px;
          padding: 38px 26px;
          width: 430px;

          background: #ffffff;
          box-shadow: 0px 0 53px 0px rgba(61, 145, 61, 0.15);
          border-radius: 8px 8px 8px 8px;

          .title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 16px;

            .left {
              font-weight: 600;
              font-size: 18px;
              color: #14211b;
              text-align: left;
            }

            .right {
              font-weight: 600;
              font-size: 23px;
              color: #14211b;
              text-align: right;
            }
          }

          .productView {
            .title {
              font-weight: 600;
              font-size: 16px;
              color: #14211b;
              text-align: left;
              margin-bottom: 14px;
            }

            .product {
              display: flex;

              flex-wrap: wrap;

              .active {
                border: 1px solid #4eab4e !important;
                color: #4eab4e !important;
              }

              .item {
                height: 40px;
                width: 30%;
                margin-right: 2%;
                margin-bottom: 10px;
                line-height: 40px;
                border-radius: 7px 7px 7px 7px;
                border: 1px solid #dadada;
                text-align: center;
                color: #14211b;
                cursor: pointer;
                font-weight: 600;
                font-size: 18px;
              }
            }
          }

          .title_2 {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 8px;
            font-weight: 500;
            font-size: 14px;
            color: #999c9a;

            .left {
            }

            .right {
            }
          }

          .title_3 {
            font-weight: 600;
            font-size: 18px;
            color: #14211b;
            text-align: left;
            margin-top: 16px;
            margin-bottom: 10px;
          }

          .dayView {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;

            .day {
              // flex: 1;
              height: 40px;
              width: 30%;
              line-height: 40px;
              border-radius: 9px;
              background: #f2f5f5;
              border-radius: 49px;
              text-align: center;
              color: #14211b;
              cursor: pointer;

              .num {
                font-weight: 600;
                font-size: 20px;
                margin-right: 2px;
              }

              .text {
                font-weight: 600;
                font-size: 12px;
              }
            }

            .active {
              background-color: #f2ac3f;
              color: #fff;
              border: none;
            }
          }

          .detailed {
            margin-top: 32px;
            border-top: 1px solid #ebebeb;

            padding: 23px 0px;

            .fielded {
              flex-wrap: wrap;
            }

            .field {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 11px;
              line-height: 24px;

              .weight {
                font-weight: 600 !important;
                color: #14211b;
              }

              .left {
                text-align: left;
                font-weight: 400;
                font-size: 13px;
                color: #14211b;
              }

              .ed {
                cursor: pointer;
              }

              .right {
                display: flex;
                align-items: center;
                font-size: 13px;

                .img {
                  height: 14px;
                  margin-left: 4px;
                }

                .text_1 {
                  text-align: right;
                  display: flex;
                  align-items: center;
                }

                .question {
                  margin-left: 4px;
                  width: 14px;
                }

                .color1 {
                  font-weight: 600;
                  color: #64ceae;
                }

                .color2 {
                  font-weight: 600;
                  color: #14211b !important;
                }

                .text_2 {
                  color: #999c9a;
                  margin-right: 4px;
                  text-decoration: line-through;
                }
              }
            }
          }

          .button {
            animation: scale-up 1.7s infinite;

            margin: 30px auto 0 auto;
            margin-top: 30px;
            background: linear-gradient(157deg, #9deb93 0%, #17b7bd 100%);
            border-radius: 12px 12px 12px 12px;
            text-align: center;
            line-height: 60px;
            cursor: pointer;
            font-weight: 600;
            font-size: 20px;
            color: #ffffff;
          }

          .buttonJIeshi {
            margin-top: 20px;
            font-size: 12px;
            text-align: left;
            line-height: 18px;
            font-size: 10px;
            opacity: 0.8;
          }
        }

        .view_3 {
          display: none;
        }
      }
    }
  }

  .advantageView {
    margin-top: 50px;
  }
}

@media only screen and (max-width: 901px) {
  .home {
    background-color: #f7f6f8;

    .body {
      background-image: url("../assets/view/11180-min.png");
      background-repeat: no-repeat;
      background-color: linear-gradient(157deg, #9deb93 0%, #17b7bd 100%);
      // background-position: 50%;
      background-size: 100% 250px;

      .viewBody {
        padding: 30px 15px 0 15px;

        .view_1 {
          display: none;
          background: linear-gradient(157deg, #9deb93 0%, #17b7bd 100%);
          padding: 20px;
          text-align: center;

          ._1 {
            font-weight: 600;
            font-size: 18px;
            color: #ffffff;
            line-height: 28px;

            span {
              color: #fff52f;
            }
          }

          ._2 {
            font-weight: 400;
            font-size: 12px;
            color: #ffffff;
            margin-top: 8px;
            line-height: 18px;
          }
          .store {
            display: flex;
            align-items: center;

            margin-top: 15px;
            .img {
              height: 38px;
              margin-right: 10px;
            }
          }
        }

        .view_2 {
          padding: 20px 20px;
          margin-top: 50px;
          border-radius: 18px;
          background-color: #fff;

          .title {
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: space-between;
            margin-bottom: 14px;

            .left {
              font-size: 16px;
              color: #a6a6a6;
              text-align: center;
              font-weight: 400;
            }

            .right {
              font-weight: 600;
              font-size: 30px;
              color: #353333;
              text-align: center;
              margin: 8px 0;
            }
          }

          .productView {
            .title {
              font-weight: 600;
              font-size: 16px;
              color: #14211b;
              text-align: left;
              margin-bottom: 14px;
            }

            .product {
              display: flex;

              flex-wrap: wrap;

              .active {
                border: 1px solid #4eab4e !important;
                color: #4eab4e !important;
              }

              .item {
                height: 40px;
                width: 30%;
                margin-right: 2%;
                margin-bottom: 10px;
                line-height: 40px;
                border-radius: 7px 7px 7px 7px;
                border: 1px solid #dadada;
                text-align: center;
                color: #14211b;
                cursor: pointer;
                font-weight: 600;
                font-size: 18px;
              }
            }
          }

          .title_2 {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 8px;
            font-weight: 500;
            font-size: 12px;
            color: #999c9a;

            .left {
            }

            .right {
            }
          }

          .title_3 {
            font-weight: 600;
            font-size: 16px;
            color: #14211b;
            text-align: left;
            margin-top: 15px;
            margin-bottom: 8px;
          }

          .dayView {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;

            .day {
              background: #f2f5f5;
              width: 85px;
              padding: 6px 0;
              border-radius: 50px;
              text-align: center;
              color: #14211b;
              cursor: pointer;

              .num {
                font-weight: 600;
                font-size: 15px;
                margin-right: 2px;
              }

              .text {
                font-weight: 600;
                font-size: 11px;
              }
            }

            .active {
              background-color: #f2ac3f;
              color: #fff;
              border: none;
            }
          }

          .detailed {
            margin-top: 15px;
            background: #f5f7f5;
            border-radius: 7px 7px 7px 7px;
            padding: 15px 18px 9px 18px;

            .fielded {
              flex-wrap: wrap;
            }

            .field {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 6px;
              line-height: 24px;

              .weight {
                font-weight: 600 !important;
                color: #14211b;
              }

              .left {
                text-align: left;
                font-weight: 400;
                font-size: 13px;
                color: #14211b;
              }

              .ed {
                cursor: pointer;
              }

              .right {
                display: flex;
                align-items: center;
                font-size: 13px;

                .img {
                  height: 14px;
                  margin-left: 4px;
                }

                .text_1 {
                  text-align: right;
                  display: flex;
                  align-items: center;
                }

                .question {
                  margin-left: 4px;
                  width: 14px;
                }

                .color1 {
                  font-weight: 600;
                  color: #64ceae;
                }

                .color2 {
                  font-weight: 600;
                  color: #14211b !important;
                }

                .text_2 {
                  color: #999c9a;
                  margin-right: 4px;
                  text-decoration: line-through;
                }
              }
            }
          }

          .button {
            animation: scale-up 1.7s infinite;
            margin-top: 30px;
            background: linear-gradient(157deg, #9deb93 0%, #17b7bd 100%);
            border-radius: 12px;
            text-align: center;
            line-height: 50px;
            cursor: pointer;
            font-weight: 600;
            font-size: 16px;
            color: #ffffff;
          }

          .buttonJIeshi {
            margin-top: 20px;
            font-size: 10px;
            opacity: 0.8;
            text-align: left;
            line-height: 18px;
          }
        }

        .view_3 {
          margin-top: 16px;
          background: linear-gradient(157deg, #9deb93 0%, #17b7bd 100%);
          padding: 20px 10px;
          text-align: center;
          border-radius: 18px;
          ._1 {
            font-weight: 600;
            font-size: 16px;
            color: #ffffff;
            line-height: 28px;
            span {
              color: #fff52f;
            }
          }

          ._2 {
            font-weight: 400;
            font-size: 12px;
            color: #ffffff;

            line-height: 18px;
          }
          .store {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 15px;
            .img {
              height: 38px;
              margin-right: 10px;
            }
          }
        }
      }
    }
  }
}
@keyframes scale-up {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.9);
  }

  100% {
    transform: scale(1);
  }
}
</style>
